module.exports = __webpack_public_path__ + "img/down_point_select.b250e501.svg";